// Sesli ve tarayıcı bildirimi yardımcıları
// - "ding" sesi Web Audio API ile üretilir (harici dosya gerektirmez)
// - browser Notification API kullanılır (kullanıcı izni gerekir)
// - kullanıcı tercihi localStorage'da saklanır

const STORAGE_KEY_ENABLED = "erp_alerts_enabled";
const STORAGE_KEY_SEEN = "erp_alerts_seen";
const STORAGE_KEY_PROD = "erp_alerts_last_prod_count";
const STORAGE_KEY_SHIP = "erp_alerts_last_ship_count";

let audioCtx = null;

export const alertsEnabled = () => localStorage.getItem(STORAGE_KEY_ENABLED) !== "0";
export const setAlertsEnabled = (v) => localStorage.setItem(STORAGE_KEY_ENABLED, v ? "1" : "0");

export const requestNotifPermission = async () => {
  if (!("Notification" in window)) return "unsupported";
  if (Notification.permission === "granted") return "granted";
  if (Notification.permission === "denied") return "denied";
  const r = await Notification.requestPermission();
  return r;
};

export const playDing = (kind = "info") => {
  if (!alertsEnabled()) return;
  try {
    if (!audioCtx) audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    const ctx = audioCtx;
    // Farklı olaylara farklı tonlar
    const tones = {
      critical: [880, 660],  // 2-notes alarm
      production_new: [523, 659, 784],  // C-E-G (majör akor)
      production_done: [784, 659, 523],  // G-E-C (tamamlandı)
      shipment: [440, 554, 659],  // A-Db-E
      info: [660],
    };
    const notes = tones[kind] || tones.info;
    let t = ctx.currentTime;
    notes.forEach((freq, i) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = "sine";
      o.frequency.setValueAtTime(freq, t);
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(0.15, t + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, t + 0.28);
      o.connect(g); g.connect(ctx.destination);
      o.start(t); o.stop(t + 0.32);
      t += 0.22;
    });
  } catch (e) { /* audio may fail on some browsers */ }
};

export const showNotif = (title, body, tag) => {
  if (!alertsEnabled()) return;
  if (!("Notification" in window)) return;
  if (Notification.permission !== "granted") return;
  try {
    const n = new Notification(title, { body, tag: tag || "erp", icon: "/favicon.ico", requireInteraction: false });
    setTimeout(() => { try { n.close(); } catch {} }, 8000);
  } catch (e) {}
};

const getSeen = () => {
  try { return new Set(JSON.parse(localStorage.getItem(STORAGE_KEY_SEEN) || "[]")); }
  catch { return new Set(); }
};
const setSeen = (set) => {
  const arr = Array.from(set).slice(-500);  // en fazla 500 tut
  localStorage.setItem(STORAGE_KEY_SEEN, JSON.stringify(arr));
};

// Bildirim listesindeki yeni kritik girdileri tespit et → ses + notif çal
export const handleNotificationsBatch = (notifs) => {
  if (!alertsEnabled()) return;
  const seen = getSeen();
  const newCriticals = [];
  for (const n of notifs || []) {
    const key = `${n.kind}-${n.source_id || n.id || n.message}`;
    if (seen.has(key)) continue;
    seen.add(key);
    if (n.severity === "critical" || n.severity === "missing") {
      newCriticals.push(n);
    }
  }
  setSeen(seen);
  if (newCriticals.length > 0) {
    playDing("critical");
    const first = newCriticals[0];
    showNotif(`⚠ Kritik Uyarı${newCriticals.length > 1 ? ` (+${newCriticals.length - 1})` : ""}`, first.message || "", "erp-critical");
  }
};

// Üretim/sevkiyat sayısı arttığında ses+notif
export const detectProdShipEvents = (prodCount, shipCount) => {
  if (!alertsEnabled()) return;
  const lastProd = parseInt(localStorage.getItem(STORAGE_KEY_PROD) || "-1", 10);
  const lastShip = parseInt(localStorage.getItem(STORAGE_KEY_SHIP) || "-1", 10);
  if (lastProd >= 0 && prodCount > lastProd) {
    playDing("production_new");
    showNotif("🏭 Yeni Üretim Emri", `${prodCount - lastProd} yeni üretim eklendi`, "erp-prod-new");
  }
  if (lastShip >= 0 && shipCount > lastShip) {
    playDing("shipment");
    showNotif("🚚 Sevkiyat Kaydı", `${shipCount - lastShip} yeni sevkiyat kaydedildi`, "erp-shipment");
  }
  localStorage.setItem(STORAGE_KEY_PROD, String(prodCount));
  localStorage.setItem(STORAGE_KEY_SHIP, String(shipCount));
};

export const detectProductionCompleted = (prevList, newList) => {
  if (!alertsEnabled()) return;
  if (!prevList || prevList.length === 0) return;
  const prevMap = new Map(prevList.map(p => [p.id, p.status]));
  for (const p of newList || []) {
    const prev = prevMap.get(p.id);
    if (prev && prev !== "completed" && p.status === "completed") {
      playDing("production_done");
      showNotif("✅ Üretim Tamamlandı", `${p.prod_no || p.number || ""} — ${p.product_name || ""}`, `erp-prod-done-${p.id}`);
    }
  }
};
